import React from 'react';
import PropTypes from 'prop-types';
import TaskInvoicesTable from './TaskInvoicesTable';
import { NO_CHARGES_POSTED } from '../../../utils/taskInvoice';

// Seller task view: read-only list of the task's charges and their invoices.
const TaskChargesInvoicesSection = ({ invoices, loading = false }) => (
    <div className="incoming_wrapper main_content_table fontFix addressDetailWrapper mt-3">
        <div className="input-label-txt mb-2"><strong>Charges &amp; Invoices</strong></div>
        <TaskInvoicesTable invoices={invoices} loading={loading} emptyText={NO_CHARGES_POSTED} />
    </div>
);

TaskChargesInvoicesSection.propTypes = {
    invoices: PropTypes.arrayOf(PropTypes.object).isRequired,
    loading: PropTypes.bool,
};

export default TaskChargesInvoicesSection;
